import React from 'react';
import CustomButton from '../../../common/components/CustomButton';
import CustomCheckbox from '../../../common/components/CustomCheckbox';
import PopupContainer from '../../../common/components/PopupContainer';

export default function MusicAlbumEditForm4DistributionPopup2({
  onClose,
  onNext,
} : {
  onClose: () => void,
  onNext: () => void,
}) {
  const [agreement1, setAgreement1] = React.useState(false);
  const [agreement2, setAgreement2] = React.useState(false);
  const [agreement3, setAgreement3] = React.useState(false);
  const [agreement4, setAgreement4] = React.useState(false);
  const [agreement5, setAgreement5] = React.useState(false);
  const [agreement6, setAgreement6] = React.useState(false);
  const disabled = !agreement1
    || !agreement2
    || !agreement3
    || !agreement4
    || !agreement5
    || !agreement6;

  return (
    <PopupContainer title="音楽配信サービス" onClose={() => { onClose(); }}>
      <div className="list__body album_delivery">
        <ul className="notes_box">
          <span className="notes red">以下すべてをお読みいただき、チェックを入れてください。</span>
        </ul>
        <dl>
          <dd>
            <CustomCheckbox checked={agreement1} setChecked={(checked) => setAgreement1(checked)}>
              お申し込みから約50日以内に配信されます。配信開始日は設定できません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement2} setChecked={(checked) => setAgreement2(checked)}>
              お申込み後のキャンセルや修正はできません。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement3} setChecked={(checked) => setAgreement3(checked)}>
              売上が反映されるのは約6ヶ月後となります。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement4} setChecked={(checked) => setAgreement4(checked)}>
              mp3をwav形式に変換して配信先に納品されます。そのためCD音質などと表示されたり、音質が変わることがあります。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement5} setChecked={(checked) => setAgreement5(checked)}>
              審査により一部の配信先に配信されない場合がございます。また、配信先は予告なく追加・削除されることがあります。
            </CustomCheckbox>
            <CustomCheckbox checked={agreement6} setChecked={(checked) => setAgreement6(checked)}>
              不正利用（収益目的の過剰な再生、第三者の権利侵害など）が発覚したり、配信先の規格に合わない音源を何度も申し込んだりした場合、サービスの提供を中止することがあります。
            </CustomCheckbox>
          </dd>
        </dl>
        <p>
          音楽配信サービスについて分からないことがある場合、申し込み前に
          <a href="https://help.frekul.com/?s=%E9%9F%B3%E6%A5%BD%E9%85%8D%E4%BF%A1%E3%82%B5%E3%83%BC%E3%83%93%E3%82%B9+" target="_blank" rel="noreferrer">ヘルプ</a>
          をご確認ください。
        </p>
        <p className="top_line" />
        <ul>
          <li className="bt">
            <CustomButton type="cancel-split" onClick={() => onClose()}>キャンセル</CustomButton>
            <CustomButton type="default-split" disabled={disabled} onClick={() => onNext()}>同意して次へ</CustomButton>
          </li>
        </ul>
      </div>
    </PopupContainer>
  );
}
